import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import "./Footer.css";

const Footer = () => {
  const [footer, setFooter] = useState({
    logo: "",
    description: "",
    email: "",
    phone: "",
    address: "",
    copyright: "",
    socials: {
      facebook: "",
      instagram: "",
      linkedin: "",
      youtube: "",
    },
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      setFooter({
        logo: data?.company_logo?.value || data?.company_logo || "/tele.png",

        description:
          data?.footer_description?.value || data?.footer_description || "",

        email: data?.support_email?.value || data?.support_email || "",

        phone: data?.support_phone?.value || data?.support_phone || "",

        address: data?.company_address?.value || data?.company_address || "",

        copyright: data?.copyright?.value || data?.copyright || "",

        socials: {
          facebook: data?.facebook_link?.value || data?.facebook_link || "",
          instagram: data?.instagram_link?.value || data?.instagram_link || "",
          linkedin: data?.linkedin_link?.value || data?.linkedin_link || "",
          youtube: data?.youtube_link?.value || data?.youtube_link || "",
        },
      });
    };

    fetchSettings();
  }, []);

  return (
    <footer className="footer py-4">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <img
              src={footer.logo}
              alt="Company Logo"
              className="footer-logo mb-2"
            />
            {footer.description && (
              <p className="footer-text mb-0">{footer.description}</p>
            )}
          </div>

          <div className="col-md-6 d-flex justify-content-md-end justify-content-center">
            <div className="text-start footer-contact-wrapper">
              <div className="mb-2">
                <span className="footer-btn fw-semibold">Contact</span>
              </div>

              <div className="footer-contact small">
                {footer.email && (
                  <div className="d-flex align-items-start gap-2">
                    <i className="bi bi-envelope"></i>
                    <a
                      href={`mailto:${footer.email}`}
                      className="footer-contact-link"
                    >
                      {footer.email}
                    </a>
                  </div>
                )}

                {footer.phone && (
                  <div className="d-flex align-items-start gap-2">
                    <i className="bi bi-telephone"></i>
                    <a
                      href={`tel:${footer.phone}`}
                      className="footer-contact-link"
                    >
                      {footer.phone}
                    </a>
                  </div>
                )}

                {footer.address && (
                  <div className="d-flex align-items-start gap-2">
                    <i className="bi bi-geo-alt"></i>
                    <span className="footer-address">{footer.address}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="row align-items-center pt-2">
          <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
            <p className="footer-copy mb-0">
              © {new Date().getFullYear()} <b>{footer.copyright}</b> All rights
              reserved.
            </p>
          </div>

          <div className="col-md-6 text-center text-md-end">
            {footer.socials.youtube && (
              <a
                href={footer.socials.youtube}
                target="_blank"
                rel="noreferrer"
                className="footer-social-link me-3"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube"></i>
              </a>
            )}

            {footer.socials.facebook && (
              <a
                href={footer.socials.facebook}
                target="_blank"
                rel="noreferrer"
                className="footer-social-link me-3"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
            )}

            {footer.socials.instagram && (
              <a
                href={footer.socials.instagram}
                target="_blank"
                rel="noreferrer"
                className="footer-social-link me-3"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
            )}

            {footer.socials.linkedin && (
              <a
                href={footer.socials.linkedin}
                target="_blank"
                rel="noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
